'use strict';

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol['for'] && Symbol['for']("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _button = require('common/components/button');

var _button2 = _interopRequireDefault(_button);

var _baseForm = require('common/components/base-form');

var _baseForm2 = _interopRequireDefault(_baseForm);

var _hfReactHelper = require('common/utils/hf-react-helper');

var _hfReactHelper2 = _interopRequireDefault(_hfReactHelper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/**
 * NOTE: This form does not follow the proper way to use
 * React and Symfony Forms, a better example can be found
 * by looking at ForgotPasswordForm
 */
var PaymentForm = _baseForm2['default'].createFormClass({

    displayName: 'PaymentForm',

    propTypes: {
        'stripeToken': _react2['default'].PropTypes.string,
        'planId': _react2['default'].PropTypes.string,
        'couponCode': _react2['default'].PropTypes.string,
        'timePeriod': _react2['default'].PropTypes.string,
        'tabOffset': _react2['default'].PropTypes.number,
        'card': _react2['default'].PropTypes.object,
        'isApi': _react2['default'].PropTypes.bool,
        'isEventbrite': _react2['default'].PropTypes.bool,
        'termsAccepted': _react2['default'].PropTypes.bool,
        'buttonText': _react2['default'].PropTypes.string,
        'headerText': _react2['default'].PropTypes.string,
        'billingString': _react2['default'].PropTypes.object,
        'ccExpiration': _react2['default'].PropTypes.string,
        'formAction': _react2['default'].PropTypes.string,
        'numSeats': _react2['default'].PropTypes.number
    },

    CARD_TYPES: [{ 'long': 'MasterCard', 'short': 'mastercard' }, { 'long': 'Visa', 'short': 'visa' }, { 'long': 'American Express', 'short': 'amex' }, { 'long': 'Discover', 'short': 'discover' }],

    getDefaultProps: function getDefaultProps() {
        return {
            'formAction': '',
            'numSeats': 1
        };
    },

    getInitialState: function getInitialState() {
        return {
            'card': $.extend({
                'expYear': new Date().getFullYear() + 1,
                'expMonth': '01',
                'number': '0',
                'cvv': '000',
                'type': 'Unknown'
            }, this.props.card),
            'isProcessing': false,
            'termsAccepted': this.props.termsAccepted || false,
            'stripeToken': this.props.stripeToken || ''
        };
    },

    onContinueClick: function onContinueClick(evt) {

        evt.preventDefault();

        var card = this.state.card;

        if (!card.suffix && (!card.name || card.name.length < 1)) {
            this.setState({
                'errors': { 'global': "Cardholder name is required." },
                'isProcessing': false
            });
            return;
        }

        if (this.state.isProcessing === false) {

            this.setState({
                'errors': null,
                'isProcessing': true
            });

            if (this.props.isApi && !this.props.isEventbrite && this.state.termsAccepted === false) {
                this.setState({
                    'errors': { 'global': "You need to accept the terms to sign up." },
                    'isProcessing': false
                });
                return;
            }

            if (card.suffix) {
                this.submitForm();
                return;
            }

            Stripe.card.createToken({
                'number': card.number,
                'cvc': card.cvv,
                'exp_month': card.expMonth,
                'exp_year': card.expYear,
                'address_zip': card.zip,
                'name': card.name
            }, function (status, response) {
                if (response.error) {
                    this.setState({
                        'errors': { 'global': response.error.message },
                        'isProcessing': false
                    });
                } else {
                    var token = response.id;
                    this.setState({
                        'stripeToken': token
                    });
                    this.submitForm();
                }
            }.bind(this));
        }

        return false;
    },

    submitForm: function submitForm() {
        $("#payment_form").submit();
    },

    onCardType: function onCardType(event) {
        var card = this.state.card;
        card.type = Stripe.cardType(event.target.value);
        card.number = event.target.value;
        this.setState({ 'card': card });
    },

    onExpMonthChange: function onExpMonthChange(event) {
        var card = this.state.card;
        card.expMonth = event.target.value;
        this.setState({ 'card': card });
    },

    onExpYearChange: function onExpYearChange(event) {
        var card = this.state.card;
        card.expYear = event.target.value;
        this.setState({ 'card': card });
    },

    onCvvChange: function onCvvChange(event) {
        var card = this.state.card;
        card.cvv = event.target.value;
        this.setState({ 'card': card });
    },

    onZipChange: function onZipChange(event) {
        var card = this.state.card;
        card.zip = event.target.value;
        this.setState({ 'card': card });
    },

    onCardholderNameChange: function onCardholderNameChange(event) {
        var card = this.state.card;
        card.name = event.target.value;
        this.setState({ 'card': card });
    },

    onTermsChange: function onTermsChange(event) {
        this.setState({
            'termsAccepted': event.target.checked,
            'errors': null
        });
    },

    render: function render() {
        var formFields;
        var termsAgreement;
        var stripeTokenField;
        var card = this.state.card;
        var tabOffset = parseInt(this.props.tabOffset || 1000, 10);

        // Stripe token
        if (this.state.stripeToken) {
            stripeTokenField = _jsx('input', {
                type: 'hidden',
                name: 'payment[stripe_token]',
                value: this.state.stripeToken
            });
        }

        // Terms agreement
        if (this.props.isApi && !this.props.isEventbrite) {
            termsAgreement = _jsx('div', {
                className: 'l-padding-b-20 columns small-12 text-left'
            }, void 0, _jsx('div', {
                className: 'm-payment--api-terms'
            }, void 0, _jsx('input', {
                id: 'payment_terms',
                type: 'checkbox',
                onChange: this.onTermsChange,
                tabIndex: tabOffset + 6,
                checked: this.state.termsAccepted
            }), _jsx('label', {
                htmlFor: 'payment_terms'
            }, void 0, ' By using our API, you agree to our ', _jsx('a', {
                target: '_blank',
                href: '/api/terms'
            }, void 0, 'API Terms of Service'), '.')));
        }

        var longDescription = _jsx('div', {
            className: 'm-payment--left-border columns small-12 text-left'
        }, void 0, _jsx('p', {}, void 0, this.props.billingString));

        var cardDisplays = this.CARD_TYPES.map(function (type, i) {
            return _jsx('img', {
                src: _hfReactHelper2['default'].imgHelper('api/pricing/upgrade_popup/' + type["short"] + '_' + (card.type == type["long"] ? '' : 'in') + 'active.png')
            }, i);
        }.bind(this));

        // Form fields
        if (!card.suffix) {

            var curYear = new Date().getFullYear();
            var numYears = 10;
            var yearOptions = Array.apply(null, Array(numYears)).map(function (val, offset) {
                var year = curYear + offset;
                return _jsx('option', {
                    value: year
                }, void 0, year);
            });

            formFields = _jsx('div', {}, void 0, _jsx('div', {
                className: 'row'
            }, void 0, _jsx('div', {
                className: 'columns small-12 text-left'
            }, void 0, _jsx('p', {}, void 0, 'Enter your credit card information'))), _jsx('div', {
                className: 'row'
            }, void 0, _jsx('div', {
                className: 'columns small-12 large-7'
            }, void 0, _jsx('div', {
                className: 'row'
            }, void 0, _jsx('div', {
                className: 'columns small-12'
            }, void 0, _jsx('input', {
                type: 'text',
                placeholder: 'Cardholder Name',
                className: 'm-payment--cardholder-name columns small-8',
                value: card.name,
                onChange: this.onCardholderNameChange,
                tabIndex: tabOffset
            }))), _jsx('div', {
                className: 'row'
            }, void 0, _jsx('div', {
                className: 'columns small-12 m-payment--cc'
            }, void 0, _jsx('input', {
                type: 'text',
                placeholder: 'Credit card number',
                onInput: this.onCardType,
                tabIndex: tabOffset + 1
            }), _jsx('div', {
                className: 'm-payment--ccs show-for-medium-up'
            }, void 0, cardDisplays))), _jsx('div', {
                className: 'row'
            }, void 0, _jsx('div', {
                className: 'columns small-12 large-6 small-text-left large-text-right'
            }, void 0, _jsx('select', {
                className: 'm-payment--cc-exp-month columns small-4',
                value: card.expMonth,
                onChange: this.onExpMonthChange,
                tabIndex: tabOffset + 2
            }, void 0, _jsx('option', {
                value: '01'
            }, void 0, '01'), _jsx('option', {
                value: '02'
            }, void 0, '02'), _jsx('option', {
                value: '03'
            }, void 0, '03'), _jsx('option', {
                value: '04'
            }, void 0, '04'), _jsx('option', {
                value: '05'
            }, void 0, '05'), _jsx('option', {
                value: '06'
            }, void 0, '06'), _jsx('option', {
                value: '07'
            }, void 0, '07'), _jsx('option', {
                value: '08'
            }, void 0, '08'), _jsx('option', {
                value: '09'
            }, void 0, '09'), _jsx('option', {
                value: '10'
            }, void 0, '10'), _jsx('option', {
                value: '11'
            }, void 0, '11'), _jsx('option', {
                value: '12'
            }, void 0, '12')), _jsx('select', {
                className: 'm-payment--cc-exp-year columns small-8',
                value: card.expYear,
                onChange: this.onExpYearChange,
                tabIndex: tabOffset + 3
            }, void 0, yearOptions)), _jsx('div', {
                className: 'columns small-12 large-6 large-text-left small-text-right'
            }, void 0, _jsx('input', {
                type: 'text',
                placeholder: 'CVV',
                className: 'm-payment--cvv columns small-4',
                onChange: this.onCvvChange,
                tabIndex: tabOffset + 4
            }), _jsx('input', {
                type: 'text',
                placeholder: 'Zip code',
                name: 'payment[cc_zip]',
                className: 'm-payment--zip columns small-8',
                onChange: this.onZipChange,
                tabIndex: tabOffset + 5
            })))), _jsx('div', {
                className: 'columns small-12 large-5'
            }, void 0, longDescription)));
        } else if (this.props.monthlyExpectedRate == 0) {
            formFields = _jsx('div', {}, void 0, _jsx('div', {
                className: 'row'
            }, void 0, _jsx('div', {
                className: 'columns small-12 text-left'
            }, void 0, _jsx('p', {}, void 0, this.props.billingString))));
        } else {
            formFields = _jsx('div', {}, void 0, _jsx('div', {
                className: 'row'
            }, void 0, _jsx('div', {
                className: 'columns small-12 text-left'
            }, void 0, _jsx('p', {}, void 0, 'The following card will be charged:'))), _jsx('div', {
                className: 'row'
            }, void 0, _jsx('div', {
                className: 'columns small-12 text-left'
            }, void 0, _jsx('h4', {}, void 0, 'xxxx xxxx xxxx ', this.state.card.suffix), _jsx('h4', {}, void 0, 'Expires ', this.props.ccExpiration, ' ')), longDescription));
        }

        return _jsx('div', {
            className: 'm-payment'
        }, void 0, _jsx('form', {
            id: 'payment_form',
            action: this.props.formAction,
            method: 'POST',
            onSubmit: this.onContinueClick
        }, void 0, _jsx('div', {
            className: 'row'
        }, void 0, _jsx('div', {
            className: 'columns small-12 text-center l-padding-v-20'
        }, void 0, _jsx('h3', {}, void 0, this.props.headerText))), formFields, _jsx('div', {
            className: 'row l-padding-v-20'
        }, void 0, termsAgreement, _jsx('div', {
            className: 'columns small-6 text-left m-payment--error'
        }, void 0, this.renderErrorText()), _jsx('div', {
            className: 'columns small-12 text-center'
        }, void 0, _jsx(_button2['default'], {
            onClick: this.onContinueClick,
            buttonText: this.props.buttonText || 'Continue',
            buttonColor: 'grasshopper',
            buttonHoverColor: 'castle-rock',
            buttonTabIndex: tabOffset + 7
        }))), stripeTokenField, this.renderCsrfField(), _jsx('input', {
            type: 'hidden',
            name: 'cardHolderName',
            value: card.name
        }), _jsx('input', {
            type: 'hidden',
            name: 'payment[num_seats]',
            value: this.props.numSeats
        }), _jsx('input', {
            type: 'hidden',
            name: 'payment[target_plan]',
            value: this.props.planId
        }), _jsx('input', {
            type: 'hidden',
            name: 'payment[coupon_code]',
            value: this.props.couponCode || ""
        }), _jsx('input', {
            type: 'hidden',
            name: 'payment[period]',
            value: this.props.timePeriod
        })));
    }
});

module.exports = PaymentForm;


/*****************
 ** WEBPACK FOOTER
 ** ./src/hellosign/components/pricing/payment-form.jsx
 ** module id = 783
 ** module chunks = 0
 **/